export class CachedGame {
  public songs: Array<string> = [];
}
